class CompleteTheLook extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        console.log('Complete the look connected')
        this.connectSplide();
        this.addEventListener('variantChange', this.handleChange);
    }
    connectSplide = () => {
        this.splideElement = this.querySelector('.splide');
        this.splideInstance = new Splide(this.splideElement, JSON.parse(this.splideElement.dataset.splide));
        this.splideInstance.mount();
    }
    handleChange = () => {
        console.log("Variant has changed");
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.section);
        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newBlock = doc.querySelector(`#${this.id}`);
                if (newBlock) {
                    this.innerHTML = newBlock.innerHTML;
                    this.connectSplide();
                }
            })
            .catch(error => console.error('Error fetching updated block:', error));
    }
}
customElements.define('complete-the-look', CompleteTheLook);